<template>
  <div>
    <div class="row">

        <div class="form-group col-sm-12 col-md-6" >
          <label for="nbResponses" class="required">How many responses would you like
            <span v-if="errorNbResponses" class="error">{{ errorNbResponses }}</span>
          </label>
          <v-select2 id="nbResponses" label="name" :options="nbResponses" v-model="question.nb_response"/>
        </div>
        <div class="col-xs-12">
          <span class="help-block">Our default recommendation is about 4 to 6 to have a manageable yet diverse number. From an expert stand point, knowing that many of them are contacted lowers the attractiveness of your question.</span>
        </div>

    </div>

    <div class="row">

      <div class="col-xs-12" style="margin-bottom: 15px">
        <label>Geographical or non-competitive preferences </label>
        <span class="help-block m-b-none">Specify below your preferences or restrictions about any countries or companies from where to source responses.</span>
      </div>

      <div class="col-xs-12 col-sm-6" >
        <div class="form-group">
          <label for="knowCompanies" class="">Known companies</label>
          <textarea id="knowCompanies" class="form-control" cols="2" v-model="question.known_companies"></textarea>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6" >
        <div class="form-group">
          <label for="excludeCompanies" class="">Excluded companies</label>
          <textarea id="excludeCompanies" class="form-control" cols="2" v-model="question.excluded_companies"></textarea>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6" >
        <div class="form-group">
          <label for="excludeGeo" class="">Excluded Geographies</label>
          <tags-input id="excludeGeo" element-id="tags"
                      v-model="selectedTagsExclude"
                      :existing-tags="countries"
                      :typeahead="true" :only-existing-tags="true"/>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6" >
        <div class="form-group ">
          <label for="includeGeo" class="">Preferred Geographies</label>
          <tags-input id="includeGeo" element-id="tags"
                      v-model="selectedTagsPreferred"
                      :existing-tags="countries"
                      :typeahead="true" :only-existing-tags="true"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.css'
import '@voerro/vue-tagsinput/dist/style.css'
import vSelect2 from '../../components/utils/select2'

export default {
  components: {vSelect2},
  name: 'QuestionStep4',
  props: ['projectId', 'question'],
  watch: {
    'question.preferred_country': async function (val) {
      if (Object.keys(this.countries).length === 0) {
        await this.getCountries()
      }
      this.selectedTagsPreferred = []
      this.question.preferred_country.forEach((country) => {
        this.selectedTagsPreferred.push(country.id.toString())
      })
    },
    'question.exclude_country': async function (val) {
      if (Object.keys(this.countries).length === 0) {
        await this.getCountries()
      }
      this.selectedTagsExclude = []
      this.question.exclude_country.forEach((country) => {
        this.selectedTagsExclude.push(country.id.toString())
      })
    }
  },
  data () {
    return {
      errorNbResponses: null,
      selectedTagsPreferred: [],
      selectedTagsExclude: [],
      nbResponses: [],
      countries: {}
    }
  },
  methods: {
    submitStep: function (requiredFields) {
      return new Promise((resolve, reject) => {
        let method = (this.question.id === null ? 'post' : 'patch')

        this.errorNbResponses = null

        this.axios[method]('/question/' + (method === 'patch' ? this.question.id : ''), {
          project_id: this.projectId,
          step: 4,
          nb_response_id: this.question.nb_response === null ? null : this.question.nb_response.id,
          known_companies: this.question.known_companies,
          excluded_companies: this.question.excluded_companies,
          preferred_country: this.selectedTagsPreferred,
          exclude_country: this.selectedTagsExclude,
          required_fields: requiredFields
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 41:
                this.errorNbResponses = errors['nb_response_id'][0]
                break
            }
          })
      })
    },
    getCountries: async function () {
      if (Object.keys(this.countries).length === 0) {
        await this.axios.get('/question/countries')
          .then((response) => {
            let countries = response.data
            this.countries = {}
            countries.forEach((country) => {
              this.countries[country.id] = country.name
            })
          })
          .catch(function (error) {
          })
      }
    },
    getResources: async function () {
      this.axios.get('/question/nbResponses')
        .then((response) => {
          this.nbResponses = response.data
        })
        .catch(function (error) {
        })
      await this.getCountries()
    }
  },
  mounted () {
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionStep4.vue